class DlCollectionBestSellersM extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.dl-collection-best-sellers-m__track');
    this.previousButton = this.querySelector('.dl-collection-best-sellers-m__arrow--prev');
    this.nextButton = this.querySelector('.dl-collection-best-sellers-m__arrow--next');
    this.handleScroll = this.updateControls.bind(this);
    this.handleResize = this.updateControls.bind(this);
  }

  connectedCallback() {
    if (!this.track || !this.previousButton || !this.nextButton) return;

    this.previousButton.addEventListener('click', () => this.move(-1));
    this.nextButton.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleResize);
    requestAnimationFrame(() => this.updateControls());
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  move(direction) {
    const card = this.track.querySelector('.dl-collection-best-sellers-m__card');
    if (!card) return;

    const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
    this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
  }

  updateControls() {
    const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    this.previousButton.disabled = this.track.scrollLeft <= 1;
    this.nextButton.disabled = this.track.scrollLeft >= maximumScroll - 1 || maximumScroll === 0;
  }
}

if (!customElements.get('dl-collection-best-sellers-m')) {
  customElements.define('dl-collection-best-sellers-m', DlCollectionBestSellersM);
}
